module.exports = __webpack_public_path__ + "img/promotion-location.61f3fc75.png";